import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPTIN_ENABLED_NEW_USER = defineFcm('double_optin_enabled_new_user')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Start a Petition GDPR flow',
		description: 'This country feature config prompts the user to verify their email.',
		import: false,
	});
